@if (!hideHeader) {
  <customer-app-header class="lay-wrapper lay-wrapper--header mat-elevation-z8"></customer-app-header>
}
<div
  class="app-content"
  role="main">
  @if (showFirstVisitPopup) {
    @defer (on immediate) {
      <customer-app-first-visit-experience></customer-app-first-visit-experience>
    }
  }
  <div class="main-content-wrapper">
    <router-outlet
      style="height: 100%"
      id="main-content"
      [ngClass]="{ 'is-vis': isSidebarVisible }"
      [ngStyle]="{ width: sideBarWidth }"></router-outlet>
  </div>
  @if ((isAuthenticated$ | async) && (isAuthorized$ | async) && !healthcheckFail) {
    <customer-app-sidebar
      #sidebar
      class="side-bar-main-item"
      role="navigation"
      aria-controls="coin-apps"
      [titles]="filteredDetails"
      [showSidebarOnStart]="false"
      [default]="false"
      (sidebarToggle)="onSidebarToggle()"
      (selectItem)="onItemSelect($event)">
      <customer-app-apps
        id="coin-apps"
        role="menuitem"
        [class.full-height]="!hasDirects"
        [isExpanded]="isSidebarVisible && selectedSidebarItems.includes(0)"
        [ariaExpanded]="isSidebarVisible && selectedSidebarItems.includes(0)"
        [ngClass]="{ 'content-visible': selectedSidebarItems.includes(0) }"
        (toggle)="onItemToggle(0)"
        (closeMenu)="sidebar.onSidebarToggle()"></customer-app-apps>
      <customer-app-directs
        role="menuitem"
        [hidden]="!hasDirects"
        [isActive]="isSidebarVisible && selectedSidebarItems.includes(1)"
        [ariaExpanded]="isSidebarVisible && selectedSidebarItems.includes(1)"
        [ngClass]="{ 'content-visible': selectedSidebarItems.includes(1) }"
        (toggle)="onItemToggle(1)"
        (closeMenu)="sidebar.onSidebarToggle()"></customer-app-directs>
    </customer-app-sidebar>
  }
</div>
<customer-app-footer></customer-app-footer>
<coin-translation-viewer-banner></coin-translation-viewer-banner>
